import { useState, useEffect } from 'react';
import './NutritionistAI.css'
import { GiChoice, GiFoodTruck } from "react-icons/gi";
import { FaGlassWaterDroplet } from "react-icons/fa6";
import { CgGym } from "react-icons/cg";
import { TbBodyScan } from "react-icons/tb";
import { MdTipsAndUpdates } from "react-icons/md";
import { HiOutlineAdjustments } from "react-icons/hi";
import { FaNutritionix, FaWeight, FaBalanceScale } from "react-icons/fa";

import { useNavigate } from 'react-router-dom';

function NutritionistAI() {
    const navigate = useNavigate();
    const [num, setNum] = useState(4);

    const nutritionistQuestions = [
        { title: "Diet Goals", icon: <HiOutlineAdjustments size={30} color='#299257' />, question: "How can I adjust my diet to meet my meal planner goals based on my TDEE?" },
        { title: "Nutrient Foods", icon: <FaNutritionix size={30} color='#ff2f2f' />, question: "What are some nutrient-dense foods I should include in my diet to support my activity level and age?" },
        { title: "Weight Goals", icon: <FaWeight size={30} color='#ffc336' />, question: "Based on my BMI and weight goal, how much weight should I aim to lose or gain per week?" },
        { title: "Nutrient Balance", icon: <FaBalanceScale size={30} color='#888' />, question: "How can I improve my macronutrient and micronutrient balance if I am often low on protein, fiber, or vitamins?" },
        { title: "Cuisine Choices", icon: <GiChoice size={30} color='#235539' />, question: "Given my favorite cuisines, how can I make healthier choices when eating Italian, Mexican, Asian, etc.?" },
        { title: "Workout Nutrition", icon: <CgGym size={30} color='#FE9539' />, question: "How can I optimize my pre- and post-workout nutrition based on my TDEE and activity level?" },
        { title: "Cravings Management", icon: <GiFoodTruck size={30} color='#6c63ff' />, question: "What is the best way to manage cravings without exceeding my daily calorie limit?" },
        { title: "Body Fat", icon: <TbBodyScan size={30} color='#6DAAD6' />, question: "Based on my age and height, what should my ideal body fat percentage be to maintain good health?" },
        { title: "Age Diet", icon: <MdTipsAndUpdates size={30} color='#FE9539' />, question: "What is the best way to adjust my diet as I age to maintain muscle mass and overall health?" },
        { title: "Hydration Needs", icon: <FaGlassWaterDroplet size={30} color='#92C9F1' />, question: "How much water should I drink daily based on my weight, activity level, and goals?" }
    ];


    const handleNavigate = (question) => {
        navigate(`/ntai/${question}`); // Pass the parameter in the URL
    };


    useEffect(() => {

        const handleResize = () => {
            if (window.innerWidth <= 1200) {
                setNum(4)
            } else if (window.innerWidth <= 1500) {
                setNum(6)
            } else {
                setNum(4)
            }
        };
        handleResize()
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    // Function to randomly choose 4 items from the array
    function getRandomQuestions(arr) {
        const shuffled = arr.sort(() => 0.5 - Math.random()); // Shuffle array
        return shuffled.slice(0, num); // Return first 4 elements
    }



    return (
        <div className="dashboard-nutrition-ai-2-all-div font_family_inter white">
            <div className='dashboard-nutrition-ai-all-inner-div'>

                <h4 className="font_family_ovo no_margin">
                    Nutritionist AI
                </h4>
                <div className='dashboard-nutrition-ai-2-outer_div'>
                    {
                        getRandomQuestions(nutritionistQuestions).map((q, index) => (
                            <div key={index} className='dashboard-nutrition-ai-2-indiv-item font_family_inter font_size_14 font_weight_500 white' onClick={() => {
                                handleNavigate(q.question)
                            }}>
                                {q.icon}
                                {q.title}
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}


export default NutritionistAI;